import axios from "axios";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 20000, 
});



// ✅ GLOBAL SOLUTION: Response interceptor to handle your custom status codes
client.interceptors.response.use(
  (response) => {
    // ✅ Check for your NrksEducationResponse custom statusCode
    if (response.data && response.data.statusCode && response.data.statusCode !== 2000) {
      console.log("🔴 Custom error intercepted globally:", response.data.statusCode, response.data.message);
      
      // ✅ Create error with custom statusCode for Redux to handle
      const error = new Error(response.data.message || "Request failed");
      error.statusCode = response.data.statusCode;
      error.response = response.data;
      error.customError = true; // Flag to identify custom errors
      
      // ✅ Reject promise so it goes to catch blocks
      return Promise.reject(error);
    }
    
    // ✅ Success case - return response normally
    return response;
  },
  (error) => {
    // ✅ Handle actual HTTP errors (404, 500, network errors)
    console.error("HTTP/Network error intercepted:", error);
    
    if (error.response && error.response.data) {
      // HTTP error with response data
      const customError = new Error(error.response.data.message || `HTTP ${error.response.status} error`);
      customError.statusCode = error.response.status;
      customError.response = error.response.data;
      return Promise.reject(customError);
    }
    
    // Network error
    const networkError = new Error(error.message || "Network error occurred");
    networkError.statusCode = 'NETWORK_ERROR';
    return Promise.reject(networkError);
  }
);



export default client;
